// extracted by mini-css-extract-plugin
export default {"wrapper":"kQ-z","firstToReview":"lQ-z","productCards":"mQ-z","productCard":"nQ-z","stars":"oQ-z","hidden":"pQ-z"};